import React from 'react';
// import logo from '../../images/logo.svg';
import Link from 'react-router-dom/Link';
import { Row, Col, Button, Icon} from 'antd';
import './CallOutSection.css';
// import patent1Img from '../../images/US009639150-full-1.gif';
// import patent2Img from '../../images/US009639150-full-3.gif';
// import patent3Img from '../../images/US009639150-full-4.gif';

const CallOutSection = (props) => {
   return (
      <div className="CallOutSection--container">
      <div className="CallOutSection--container-inner">
        <div className="CallOutSection--headline">
          <h1>Real Time Touch: USPTO-Granted Patent Highlights</h1>
          
       </div>
       <div className="CallOutSection--body-text center">
         <h4>
         Real Time Touch has been granted key patents that could revolutionize telehealth and telemedicine.
         </h4>
         <h4>
         We're seeking partners to help develop innovative mobile telehealth patents in a growing multibillion dollar market.
         </h4>
        

         <Row className="CallOutSection--row1">
          <Col xs={22} sm={22} md={24} lg={24}>
          <div className="CallOutSection--img-holder">
          <Link to="https://www.realtimetouch.com/images/patents/US009639150.pdf" target="_blank">
          <img 
            className="PatentHeader--img img-responsive img-rounded-more" 
            src="https://www.realtimetouch.com/images/patents/med/US009639150-full-1.png" 
            alt="Patent US009639150"
            />
          </Link>
            <div className="clearfix PatentHeader-text-subimg">Powered Physical Displays on Mobile Devices<br/>(USPTO-granted patent)<br/>USPTO Patent US009639150</div>
        </div>   
          </Col> 
          {/* <Col xs={22} sm={22} md={12} lg={12}>
          <div className="CallOutSection--img-holder">
          <Link to="https://www.realtimetouch.com/images/patents/20170195624.pdf" target="_blank">
            <img 
              className="PatentHeader--img img-responsive img-rounded-more"
              src="https://www.realtimetouch.com/images/patents/med/US020170195624A120170706-1.png"  
              alt="Patent Appl. US020170195624A1"
              />
            </Link>
              <div className="clearfix PatentHeader-text-subimg">Powered Physical Displays on Mobile Devices<br/>(additional claims)<br/>Patent App. US20170195624A1</div>
          </div>   
          </Col> */}
          {/* <Col xs={24} sm={16} md={12} lg={8}>
          <div className="PatentHeader--img-holder">
          <Link to="https://www.realtimetouch.com/images/patents/20050177416.pdf" target="_blank">
            <img 
              className="PatentHeader--img img-responsive img-rounded-more" 
              src="https://www.realtimetouch.com/images/patents/med/20050177416-1.png" 
              alt="Patent Appl. US20050177416A1"
              />
            </Link>
              <div className="clearfix PatentHeader-text-subimg">Patent Appl. US20050177416A1</div>
          </div>   
          </Col> */}
        </Row>
          <Row>
            <Col span={24}>
              <div className="CallOutSection--button-moreinfo-container">
                <Link to="/patents/">
                  <Button size="large" type="primary"><Icon type="copy" style={{marginRight:5}}/>Real Time Touch Patents<Icon type="caret-right" /></Button>
                </Link>
              </div>
            </Col>
          </Row>
       </div>
        
      </div>
      </div>
    )
 }
 export default CallOutSection;


// WEBPACK FOOTER //
// ./src/containers/CallOutSection/CallOutSection.js